import { render, staticRenderFns } from "./StickyBookBar.vue?vue&type=template&id=5e0ef740&scoped=true&"
import script from "./StickyBookBar.vue?vue&type=script&lang=js&"
export * from "./StickyBookBar.vue?vue&type=script&lang=js&"
import style0 from "./StickyBookBar.vue?vue&type=style&index=0&id=5e0ef740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0ef740",
  null
  
)

export default component.exports